import axios from "axios";
import moment from "moment";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { RegistarController } from "../../controllers/RegistarController";
import Endpoint from "../../endpoints/Endpoint";
import EntityOperation from "../../infrastructure/EnumEntityOperation";
import Labels from "../../infrastructure/Labels_sr_Latn_RS";
import MessageType from "../../infrastructure/MessageType";
import EnumPacijentPolje from "../../infrastructure/PacijentPolje";
import Routers from "../../utils/Routers";
import { axiosConfig, CALENDAR_DATE_FORMAT, useEffectOnce } from "../../utils/Utils";
import { AppContext } from "../Store";

interface CUDialogPacijentProps {
  pacijentOperation: string;
  pacijent?: any;
  onCancel: Function;
  afterSubmit?: Function;
}
interface PacijentPolje {
  id: number;
  naziv: string;
  sifra: string;
  obavezno: boolean;
  _links: any;
}
export default function CUDialogPacijent(props: CUDialogPacijentProps) {
  const { pacijentOperation, pacijent, onCancel, afterSubmit } = props;
  const [pacijentChange, setPacijentChange] = useState<Partial<any>>(pacijent);
  const [prikazPacijentAdministrativnaNapomena, setPrikazPacijentAdministrativnaNapomena] = useState();
  const [prikazPacijentImeRoditelja, setPrikazPacijentImeRoditelja] = useState();
  const [prikazPacijentMedicinskaNapomena, setPrikazPacijentMedicinskaNapomena] = useState();
  const [prikazPacijentPrikazJednogPola, setPrikazPacijentPrikazJednogPola] = useState();
  const [prikazPacijentRadnoMesto, setPrikazPacijentRadnoMesto] = useState();
  const [prikazPacijentStrucnaSprema, setPrikazPacijentStrucnaSprema] = useState();
  const [prikazPacijentZanimanje, setPrikazPacijentZanimanje] = useState();
  const { showGrowlMessage, authData, checkFilter } = useContext(AppContext);
  const { axiosRegistarPacijentPolja } = RegistarController();
  const [pacijentPoljaObaveznostMap, setPacijentPoljaObaveznostMap] = useState<Map<string, boolean>>(new Map<string, boolean>());
  const history = useHistory();
  const registarID = JSON.parse(localStorage.getItem("odabraniRegistar") || "null");
  useEffectOnce(() => {
    const reqPacijentParametarList = axios.get(Endpoint.PACIJENT_PARAMETRI, axiosConfig(authData.token));
    const reqRegistarPacijentPolja = axiosRegistarPacijentPolja();
    axios
      .all([reqPacijentParametarList, reqRegistarPacijentPolja])
      .then(
        axios.spread((resPacijentParametarList: any, resRegistarPacijentPolja: any) => {
          setPrikazPacijentAdministrativnaNapomena(resPacijentParametarList.data.prikazPacijentAdministrativnaNapomena);
          setPrikazPacijentImeRoditelja(resPacijentParametarList.data.prikazPacijentImeRoditelja);
          setPrikazPacijentMedicinskaNapomena(resPacijentParametarList.data.prikazPacijentMedicinskaNapomena);
          setPrikazPacijentPrikazJednogPola(resPacijentParametarList.data.prikazPacijentPrikazJednogPola);
          setPrikazPacijentRadnoMesto(resPacijentParametarList.data.prikazPacijentRadnoMesto);
          setPrikazPacijentStrucnaSprema(resPacijentParametarList.data.prikazPacijentStrucnaSprema);
          setPrikazPacijentZanimanje(resPacijentParametarList.data.prikazPacijentZanimanje);
          let tempPacijentPoljaObaveznostMap = new Map<string, boolean>();
          resRegistarPacijentPolja.data._embedded?.registarPacijentPoljes.forEach((element: PacijentPolje) => {
            tempPacijentPoljaObaveznostMap.set(element.sifra, element.obavezno);
          });
          setPacijentPoljaObaveznostMap(tempPacijentPoljaObaveznostMap);
        })
      )
      .catch((error) => {
        console.log(error);
      });
  });

  const validationInput = () => {
    if (!pacijentChange) {
      showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA, Labels.MESSAGES_OBAVEZNA_POLJA);
      return false;
    }
    if (!pacijentChange.ime && pacijentPoljaObaveznostMap.get(EnumPacijentPolje.IME) && checkFilter("ime")) {
      showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA, Labels.MESSAGES_IME_PACIJENTA);
      return false;
    }
    if (!pacijentChange.prezime && pacijentPoljaObaveznostMap.get(EnumPacijentPolje.PREZIME) && checkFilter("prezime")) {
      showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA, Labels.MESSAGES_PREZIME_PACIJENTA);
      return false;
    }
    if (!pacijentChange.datumRodjenja && pacijentPoljaObaveznostMap.get(EnumPacijentPolje.DATUM_RODJENJA) && checkFilter("datumRodjenja")) {
      showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA, Labels.MESSAGES_DATUM_RODJENJA_PACIJENTA);
      return false;
    }
    if (!pacijentChange.jmbg && pacijentPoljaObaveznostMap.get(EnumPacijentPolje.JMBG) && checkFilter("jmbg")) {
      showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA, Labels.MESSAGES_JMBG_PACIJENTA);
      return false;
    }
    if (!pacijentChange.lbo && pacijentPoljaObaveznostMap.get(EnumPacijentPolje.LBO) && checkFilter("lbo")) {
      showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA, Labels.MESSAGES_LBO_PACIJENTA);
      return false;
    }
    if (pacijentPoljaObaveznostMap.get(EnumPacijentPolje.POL) && pacijentChange.polTrenutni !== true && pacijentChange.polTrenutni !== false && checkFilter("polTrenutni")) {
      showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA, Labels.MESSAGES_POL_PACIJENTA);
      return false;
    }

    if (!pacijentChange.kontaktTelefon && pacijentPoljaObaveznostMap.get(EnumPacijentPolje.KONTAKT_TELEFON) && checkFilter("kontaktTelefon")) {
      showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA, Labels.MESSAGES_KONTAKT_TELEFON_PACIJENTA);
      return false;
    }
    if (!pacijentChange.adresa && pacijentPoljaObaveznostMap.get(EnumPacijentPolje.ADRESA) && checkFilter("adresa")) {
      showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA, Labels.MESSAGES_ADRESA_PACIJENTA);
      return false;
    }
    if (!pacijentChange.zanimanje && pacijentPoljaObaveznostMap.get(EnumPacijentPolje.ZANIMANJE) && checkFilter("zanimanje")) {
      showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA, Labels.MESSAGES_ZANIMANJE_PACIJENTA);
      return false;
    }
    if (!pacijentChange.email && pacijentPoljaObaveznostMap.get(EnumPacijentPolje.EMAIL) && checkFilter("email")) {
      showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA, Labels.MESSAGES_EMAIL_PACIJENTA);
      return false;
    }

    let pattern = new RegExp("^([0-9]{3}/[0-9]{6,8})$");
    if (pacijentChange.kontaktTelefon && !pattern.test(pacijentChange.kontaktTelefon.trim())) {
      showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA, Labels.MESSAGES_OBLIK_KONTAKT_TELEFONA);
      return false;
    }

    if (pacijentChange.mobilniTelefon && !pattern.test(pacijentChange.mobilniTelefon)) {
      showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA, Labels.MESSAGES_OBLIK_MOBILNOG_TELEFONA);
      return false;
    }

    return true;
  };

  const kreirajPacijenta = () => {
    if (!validationInput()) {
      return;
    }
    let pacijentNew = {
      ...pacijentChange,
      strucna_sprema: pacijentChange?.strucnaSprema,
      mobilni_telefon: pacijentChange?.mobilniTelefon,
      kontakt_telefon: pacijentChange?.kontaktTelefon,
      broj_kartona: pacijentChange?.brojKartona,
      datum_rodjenja: pacijentChange?.datumRodjenja && moment(pacijentChange?.datumRodjenja).format("DD.MM.YYYY."),
      ime_roditelja: pacijentChange?.imeRoditelja,
      medicinska_napomena: pacijentChange?.medicinskaNapomena,
      administrativna_napomena: pacijentChange?.administrativnaNapomena,
    };
    axios
      .post(Endpoint.PACIJENT_NEW, { ...pacijentNew, registarID: registarID }, axiosConfig(authData.token))
      .then((response) => {
        showGrowlMessage(MessageType.SUCCESS, Labels.TITLE_MESSAGES_USPESNO_SNIMLJEN_PACIJENT, "");
        onCancel();
        history.push(`${Routers.PACIJENTI}/${response.data.pacijent.pacijentID}`);
      })
      .catch((error) => {
        showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA_PRILIKOM_SNIMANJA_PACIJENTA, "");
        console.log(error);
      });
  };

  const izmeniPacijenta = async () => {
    if (!validationInput()) {
      return;
    }
    let pacijentUpdate = {
      ...pacijentChange,
      strucna_sprema: pacijentChange?.strucnaSprema,
      mobilni_telefon: pacijentChange?.mobilniTelefon,
      kontakt_telefon: pacijentChange?.kontaktTelefon,
      broj_kartona: pacijentChange?.brojKartona,
      datum_rodjenja: pacijentChange?.datumRodjenja && moment(pacijentChange?.datumRodjenja).format("DD.MM.YYYY."),
      ime_roditelja: pacijentChange?.imeRoditelja,
      medicinska_napomena: pacijentChange?.medicinskaNapomena,
      administrativna_napomena: pacijentChange?.administrativnaNapomena,
    };
    await axios
      .post(Endpoint.PACIJENT_NEW, { ...pacijentUpdate, registarID: registarID }, axiosConfig(authData.token))
      .then((response) => {
        showGrowlMessage(MessageType.SUCCESS, Labels.TITLE_MESSAGES_USPESNO_IZMENJEN_PACIJENT, "");
        afterSubmit && afterSubmit(pacijent.id);
        onCancel();
      })
      .catch((error) => {
        showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA_PRILIKOM_SNIMANJA_PACIJENTA, "");
      });
  };

  return (
    <div className="col-12">
      <div className="grid align-items-center">
        {checkFilter("ime") && (
          <>
            <div className="col-4 mb-3">{pacijentPoljaObaveznostMap.get(EnumPacijentPolje.IME) ? Labels.LABEL_IME_OBAVEZNO : Labels.LABEL_IME}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.ime ? pacijentChange.ime : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    ime: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {checkFilter("prezime") && (
          <>
            <div className="col-4 mb-3">{pacijentPoljaObaveznostMap.get(EnumPacijentPolje.PREZIME) ? Labels.LABEL_PREZIME_OBAVEZNO : Labels.LABEL_PREZIME}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.prezime ? pacijentChange.prezime : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    prezime: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {prikazPacijentImeRoditelja && checkFilter("imeRoditelja") && (
          <>
            <div className="col-4 mb-3">{Labels.LABEL_IME_RODITELJA}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.imeRoditelja ? pacijentChange.imeRoditelja : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    imeRoditelja: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {checkFilter("prezime") && (
          <>
            <div className="col-4 mb-3">{pacijentPoljaObaveznostMap.get(EnumPacijentPolje.DATUM_RODJENJA) ? Labels.LABEL_DATUM_RODJENJA_OBAVEZNO : Labels.LABEL_DATUM_RODJENJA}</div>
            <div className="col-8 p-fluid p-0">
              <Calendar
                monthNavigator={true}
                yearNavigator={true}
                yearRange="1920:2030"
                dateFormat={CALENDAR_DATE_FORMAT}
                showIcon
                value={pacijentChange && pacijentChange.datumRodjenja ? new Date(pacijentChange.datumRodjenja) : undefined}
                onChange={(e: any) => {
                  if (e.target.value != null) {
                    const date = new Date(e.target.value);
                    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
                    setPacijentChange({
                      ...pacijentChange,
                      datumRodjenja: date,
                    });
                  } else {
                    setPacijentChange({
                      ...pacijentChange,
                      datumRodjenja: undefined,
                    });
                  }
                }}
              />
            </div>
          </>
        )}
        {checkFilter("jmbg") && (
          <>
            <div className="col-4 mb-3">{pacijentPoljaObaveznostMap.get(EnumPacijentPolje.JMBG) ? Labels.LABEL_JMBG_OBAVEZNO : Labels.LABEL_JMBG}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.jmbg ? pacijentChange.jmbg : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    jmbg: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {checkFilter("lbo") && (
          <>
            <div className="col-4 mb-3">{pacijentPoljaObaveznostMap.get(EnumPacijentPolje.LBO) ? Labels.LABEL_LBO_OBAVEZNO : Labels.LABEL_LBO}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.lbo ? pacijentChange.lbo : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    lbo: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {checkFilter("polTrenutni") && (
          <>
            <div className="col-4 mb-3">{pacijentPoljaObaveznostMap.get(EnumPacijentPolje.POL) ? Labels.LABEL_POL_OBAVEZNO : Labels.LABEL_POL}</div>
            <div className="col-8 p-fluid p-0">
              <RadioButton
                inputId="rb1"
                name="gender"
                checked={pacijentChange && pacijentChange.polTrenutni === true ? pacijentChange.polTrenutni : false}
                value={pacijentChange && pacijentChange.polTrenutni === true ? pacijentChange.polTrenutni : true}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    polTrenutni: e.target.value,
                  });
                }}
              />
              <label htmlFor="rb1" className="p-radiobutton-label">
                {Labels.LABEL_MUSKI}
              </label>
              <RadioButton
                inputId="rb2"
                name="gender"
                checked={pacijentChange && pacijentChange.polTrenutni === false ? !pacijentChange.polTrenutni : false}
                value={pacijentChange && pacijentChange.polTrenutni === false ? pacijentChange.polTrenutni : false}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    polTrenutni: e.target.value,
                  });
                }}
              />
              <label htmlFor="rb2" className="p-radiobutton-label">
                {Labels.LABEL_ZENSKI}
              </label>
            </div>
          </>
        )}
        {prikazPacijentPrikazJednogPola && (
          <>
            <div className="col-4 mb-3">{Labels.LABEL_POL_NA_RODJENJU}</div>
            <div className="col-8 p-fluid p-0">
              <RadioButton
                name="pol"
                checked={pacijentChange && pacijentChange.polNaRodjenju === true ? pacijentChange.polNaRodjenju : false}
                value={pacijentChange && pacijentChange.polNaRodjenju === true ? pacijentChange.polNaRodjenju : true}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    polNaRodjenju: e.target.value,
                  });
                }}
              />
              <label className="p-radiobutton-label">{Labels.LABEL_MUSKI}</label>
              <RadioButton
                name="pol"
                checked={pacijentChange && pacijentChange.polNaRodjenju === false ? !pacijentChange.polNaRodjenju : false}
                value={pacijentChange && pacijentChange.polNaRodjenju === false ? pacijentChange.polNaRodjenju : false}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    polNaRodjenju: e.target.value,
                  });
                }}
              />
              <label className="p-radiobutton-label">{Labels.LABEL_ZENSKI}</label>
            </div>
          </>
        )}
        {checkFilter("adresa") && (
          <>
            <div className="col-4 mb-3">{pacijentPoljaObaveznostMap.get(EnumPacijentPolje.ADRESA) ? Labels.LABEL_ADRESA_OBAVEZNO : Labels.LABEL_ADRESA}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.adresa ? pacijentChange.adresa : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    adresa: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {checkFilter("brojKartona") && (
          <>
            <div className="col-4 mb-3">{Labels.LABEL_BROJ_KARTONA}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.brojKartona ? pacijentChange.brojKartona : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    brojKartona: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {checkFilter("kontaktTelefon") && (
          <>
            <div className="col-4 mb-3">{pacijentPoljaObaveznostMap.get(EnumPacijentPolje.KONTAKT_TELEFON) ? Labels.LABEL_KONTAKT_TELEFON_OBAVEZNO : Labels.LABEL_KONTAKT_TELEFON}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.kontaktTelefon ? pacijentChange.kontaktTelefon : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    kontaktTelefon: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {checkFilter("email") && (
          <>
            <div className="col-4 mb-3">{pacijentPoljaObaveznostMap.get(EnumPacijentPolje.EMAIL) ? Labels.LABEL_EMAIL_OBAVEZNO : Labels.LABEL_EMAIL}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.email ? pacijentChange.email : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    email: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {checkFilter("mobilniTelefon") && (
          <>
            <div className="col-4 mb-3">{Labels.LABEL_MOBILNI_TELEFON}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.mobilniTelefon ? pacijentChange.mobilniTelefon : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    mobilniTelefon: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {prikazPacijentZanimanje && checkFilter("zanimanje") && (
          <>
            <div className="col-4 mb-3">{pacijentPoljaObaveznostMap.get(EnumPacijentPolje.ZANIMANJE) ? Labels.LABEL_ZANIMANJE_OBAVEZNO : Labels.LABEL_ZANIMANJE}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.zanimanje ? pacijentChange.zanimanje : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    zanimanje: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {prikazPacijentStrucnaSprema && checkFilter("strucnaSprema") && (
          <>
            <div className="col-4 mb-3">{Labels.LABEL_STRUCNA_SPREMA}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.strucnaSprema ? pacijentChange.strucnaSprema : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    strucnaSprema: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {prikazPacijentRadnoMesto && (
          <>
            <div className="col-4 mb-3">{Labels.LABEL_RADNO_MESTO}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.radnoMesto ? pacijentChange.radnoMesto : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    radnoMesto: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {prikazPacijentMedicinskaNapomena && (
          <>
            <div className="col-4 mb-3">{Labels.LABEL_MEDICINSKA_NAPOMENA}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.medicinskaNapomena ? pacijentChange.medicinskaNapomena : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    medicinskaNapomena: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        {prikazPacijentAdministrativnaNapomena && (
          <>
            <div className="col-4 mb-3">{Labels.LABEL_ADMINISTRATIVNA_NAPOMENA}</div>
            <div className="col-8 p-fluid p-0">
              <InputText
                value={pacijentChange && pacijentChange.administrativnaNapomena ? pacijentChange.administrativnaNapomena : ""}
                onChange={(e: any) => {
                  setPacijentChange({
                    ...pacijentChange,
                    administrativnaNapomena: e.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
      </div>
      <div className="grid pt-3 justify-content-end">
        <Button label={Labels.BUTTON_SACUVAJ} icon="pi pi-save" className="p-button-info" onClick={pacijentOperation === EntityOperation.CREATE ? kreirajPacijenta : izmeniPacijenta} />
      </div>
    </div>
  );
}
